import type { TranslationSchema } from './en';

const kn: TranslationSchema = {
    // --- NAVBAR ---
    nav: {
        home: "ಮುಖಪುಟ",
        about: "ನಮ್ಮ ಬಗ್ಗೆ",
        services: "ಸೇವೆಗಳು",
        team: "ತಂಡ",
        contact: "ಸಂಪರ್ಕಿಸಿ",
        getStarted: "ಪ್ರಾರಂಭಿಸಿ",
    },

    // --- HERO SECTION ---
    hero: {
        label: "ಮುಂದಿನ ಪೀಳಿಗೆಯ ತಂತ್ರಜ್ಞಾನ ಪಾಲುದಾರ",
        title1: "ಬುದ್ಧಿವಂತ ಮತ್ತು",
        title2: "ಪ್ರಮಾಣಾನುಗುಣ ಡಿಜಿಟಲ್ ಪರಿಹಾರಗಳನ್ನು ಒದಗಿಸುತ್ತಿದ್ದೇವೆ",
        description: "ಕ್ಯಾಸ್ಕೇಡ್ ಸ್ಪೇಸ್ ಸುಧಾರಿತ ಸಾಫ್ಟ್‌ವೇರ್, ವೆಬ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ಗಳು ಮತ್ತು ಕೃತಕ ಬುದ್ಧಿಮತ್ತೆ ಪರಿಹಾರಗಳನ್ನು ನಿರ್ಮಿಸುವಲ್ಲಿ ಪರಿಣತಿ ಹೊಂದಿದೆ, ಇದು ವ್ಯವಹಾರಗಳಿಗೆ ಹೊಸತನವನ್ನು ತರಲು, ಕಾರ್ಯಾಚರಣೆಗಳನ್ನು ಸುಗಮಗೊಳಿಸಲು ಮತ್ತು ಸುಸ್ಥಿರ ಬೆಳವಣಿಗೆಯನ್ನು ಸಾಧಿಸಲು ಅಧಿಕಾರ ನೀಡುತ್ತದೆ.",
        cta1: "ನಮ್ಮ ಪರಿಣತಿಯನ್ನು ಅನ್ವೇಷಿಸಿ",
        cta2: "ನಮ್ಮ ಸಲಹೆಗಾರರನ್ನು ಸಂಪರ್ಕಿಸಿ",
        trustPowered: "AI-ಚಾಲಿತ",
        trustUptime: "99.9% ವಿಶ್ವಾಸಾರ್ಹ",
        trustSupport: "ತಜ್ಞರ ಬೆಂಬಲ",
    },

    // --- HOME SECTIONS ---
    home: {
        powLabel: "ನಾವೀನ್ಯತೆಯ ವರ್ಷಗಳು",
        powProjects: "ಯೋಜನೆಗಳು ವಿತರಿಸಲಾಗಿದೆ",
        powLive: "ಲೈವ್ ಉತ್ಪನ್ನಗಳು",
        powClient: "ಗ್ರಾಹಕ-ಕೇಂದ್ರಿತ",
        statDesc1: "2023 ರಿಂದ ನಿರ್ಮಿಸಲಾಗುತ್ತಿದೆ",
        statDesc2: "ಸ್ಟಾರ್ಟ್‌ಅಪ್‌ಗಳು ಮತ್ತು ಉದ್ಯಮಗಳಾದ್ಯಂತ",
        statDesc3: "ಸ್ಟಾರ್ಟೋಪಿಯಾ · ಟೆಕ್ಸ್ಟ್ ಯುವರ್ ಬಾಸ್.ಎಐ · ಇನ್ನಷ್ಟು",
        statDesc4: "ಫಲಿತಾಂಶ-ಚಾಲಿತ ವಿತರಣಾ ಮಾದರಿ",

        servicesLabel: "ನಮ್ಮ ಸೇವೆಗಳು",
        servicesTitle: "ನಿಮ್ಮ ವ್ಯವಹಾರವನ್ನು ಪರಿವರ್ತಿಸಲು ಸಿದ್ಧರಿದ್ದೀರಾ?",
        servicesDesc: "ಕ್ಯಾಸ್ಕೇಡ್ ಸ್ಪೇಸ್ ನಿಮ್ಮ ವ್ಯಾವಸಾಯಿಕ ಉದ್ದೇಶಗಳೊಂದಿಗೆ ಹೊಂದಿಕೆಯಾಗುವಂತೆ ವಿನ್ಯಾಸಗೊಳಿಸಲಾದ ಅತ್ಯಾಧುನಿಕ ತಂತ್ರಜ್ಞಾನ ಪರಿಹಾರಗಳನ್ನು ಒದಗಿಸುತ್ತದೆ. ನಮ್ಮ ಪರಿಣತಿಯು ಡಿಜಿಟಲ್ ಪರಿವರ್ತನೆಯಿಂದ ಕೃತಕ ಬುದ್ಧಿಮತ್ತೆಯವರೆಗೆ ವ್ಯಾಪಿಸಿದೆ, ಪ್ರತಿ ಹಂತದ ನಿಶ್ಚಿತಾರ್ಥದಲ್ಲಿ ಅಳೆಯಬಹುದಾದ ಫಲಿತಾಂಶಗಳನ್ನು ಖಚಿತಪಡಿಸುತ್ತದೆ.",
        servicesBtn: "ನಮ್ಮ ಸೇವೆಗಳನ್ನು ಅನ್ವೇಷಿಸಿ",

        hwwLabel: "ನಮ್ಮ ಪ್ರಕ್ರಿಯೆ",
        hwwTitle: "ನಾವು ಉತ್ಕೃಷ್ಟತೆಯನ್ನು ಹೇಗೆ ತಲುಪಿಸುತ್ತೇವೆ",
        hwwBody: "ನಾವು ರಚನಾತ್ಮಕ, ಪುನರಾವರ್ತಿತ ವಿಧಾನವನ್ನು ಅನುಸರಿಸುತ್ತೇವೆ — ಅನ್ವೇಷಣೆಯಿಂದ ನಿಯೋಜನೆಯವರೆಗೆ — ಪ್ರತಿ ಪರಿಹಾರವು ನಿಖರ, ಪ್ರಮಾಣಾನುಗುಣ ಮತ್ತು ಭವಿಷ್ಯಕ್ಕೆ ಸಿದ್ಧವಾಗಿದೆ ಎಂದು ಖಚಿತಪಡಿಸುತ್ತೇವೆ.",

        techBridgeLabel: "ಸೇವೆಯಿಂದ ಪರಿಹಾರಕ್ಕೆ",
        techBridgeBody: "ನಾವು ಕೇವಲ ಸಾಫ್ಟ್‌ವೇರ್ ಅನ್ನು ನಿರ್ಮಿಸುವುದಿಲ್ಲ. ನಾವು ಪರಿಸರ ವ್ಯವಸ್ಥೆಗಳನ್ನು ಆರ್ಕಿಟೆಕ್ಟ್ ಮಾಡುತ್ತೇವೆ — ನಿಮ್ಮ ಬ್ರ್ಯಾಂಡ್, ಕಾರ್ಯಾಚರಣೆಗಳು ಮತ್ತು ಗ್ರಾಹಕರನ್ನು ಒಂದೇ, ತಡೆರಹಿತ, ಬುದ್ಧಿವಂತ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ಗೆ ಸಂಪರ್ಕಿಸುತ್ತೇವೆ.",
        techBridgeCta: "ಪೂರ್ಣ ಪೋರ್ಟ್‌ಫೋಲಿಯೊ ವೀಕ್ಷಿಸಿ",

        featuresLabel: "ಕ್ಯಾಸ್ಕೇಡ್ ಪ್ರಯೋಜನ",
        featuresTitle: "ಉದ್ಯಮದ ನಾಯಕರು ನಮ್ಮನ್ನು ಏಕೆ ಆರಿಸುತ್ತಾರೆ",

        contactLabel: "ಸಹಯೋಗ",
        contactTitle: "ನಿಮ್ಮ ಡಿಜಿಟಲ್ ರೂಪಾಂತರವನ್ನು ವೇಗಗೊಳಿಸಿ",

        // Projects section
        projectsTitle: "ನಮ್ಮ ನವೀನ ಯೋಜನೆಗಳು",
        projectsDesc: "ನೈಜ-ಪ್ರಪಂಚದ ಸಮಸ್ಯೆಗಳನ್ನು ಪರಿಹರಿಸಲು ಮತ್ತು ವ್ಯಾವಸಾಯಿಕ ಬೆಳವಣಿಗೆಯನ್ನು ಹೆಚ್ಚಿಸಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾದ ನಮ್ಮ ಅತ್ಯಾಧುನಿಕ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ಗಳು ಮತ್ತು ಸಾಧನಗಳನ್ನು ಅನ್ವೇಷಿಸಿ.",
        projectsViewAll: "ಎಲ್ಲಾ ಯೋಜನೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
        projectsLearnMore: "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",
    },

    // --- ABOUT ---
    about: {
        heroLabel: "ಕ್ಯಾಸ್ಕೇಡ್ ಸ್ಪೇಸ್ ಬಗ್ಗೆ",
        heroTitle: "ತಂತ್ರಜ್ಞಾನ ಮತ್ತು ನಾವೀನ್ಯತೆಯ ಮೂಲಕ ವ್ಯವಹಾರಗಳನ್ನು ಸಬಲೀಕರಣಗೊಳಿಸುವುದು",
        heroDesc: "ನಾವು ವ್ಯಕ್ತಿಗಳು, ಸ್ಟಾರ್ಟ್‌ಅಪ್‌ಗಳು ಮತ್ತು ಉದ್ಯಮಗಳಿಗೆ ಉತ್ಪಾದಕತೆ, ದಕ್ಷತೆ ಮತ್ತು ಪ್ರಮಾಣಾನುಗುಣತೆಯನ್ನು ಹೆಚ್ಚಿಸುವ ಸ್ಮಾರ್ಟ್ ಡಿಜಿಟಲ್ ಪರಿಹಾರಗಳನ್ನು ನಿರ್ಮಿಸುತ್ತೇವೆ.",

        visionLabel: "ಭವಿಷ್ಯದ ದೃಷ್ಟಿಕೋನ",
        visionTitle: "ಜಾಗತಿಕ ತಂತ್ರಜ್ಞಾನ ಪವರ್‌ಹೌಸ್ ಆಗುವುದು",
        missionLabel: "ನಮ್ಮ ಮಿಷನ್",
        missionTitle: "ತಂತ್ರಜ್ಞಾನದ ಮೂಲಕ ಸಂಕೀರ್ಣ ಸವಾಲುಗಳನ್ನು ಸರಳೀಕರಿಸುವುದು",

        visionMissionLabel: "ನಮ್ಮ ಉದ್ದೇಶ",
        visionBody: "ನಾವೀನ್ಯತೆಯು ಗಡಿಗಳನ್ನು ಮೀರಿದ ಭವಿಷ್ಯವನ್ನು ನಿರ್ಮಿಸಲು ಕ್ಯಾಸ್ಕೇಡ್ ಸ್ಪೇಸ್ ಬದ್ಧವಾಗಿದೆ. ನಮ್ಮ ದೃಷ್ಟಿಕೋನವು ವಿಶ್ವಾದ್ಯಂತ ಕೈಗಾರಿಕೆಗಳು ಮತ್ತು ಸಮುದಾಯಗಳಲ್ಲಿ ರೂಪಾಂತರದ ಪ್ರಭಾವದೊಂದಿಗೆ ವಿಶ್ವದರ್ಜೆಯ ತಂತ್ರಜ್ಞಾನದ ಪರಿಹಾರಗಳನ್ನು ಒದಗಿಸುವುದಾಗಿದೆ.",
        missionBody: "ಕ್ಯಾಸ್ಕೇಡ್ ಸ್ಪೇಸ್‌ನಲ್ಲಿ, ನಮ್ಮ ಗುರಿ ಸಂಕೀರ್ಣತೆಯನ್ನು ಸ್ಪಷ್ಟತೆಯಾಗಿ ಬದಲಾಯಿಸುವುದು. ವೆಚ್ಚ-ಪರಿಣಾಮಕಾರಿ, ಉನ್ನತ-ಗುಣಮಟ್ಟದ ಡಿಜಿಟಲ್ ಪರಿಹಾರಗಳ ಮೂಲಕ ಸಂಸ್ಥೆಗಳಿಗೆ ಹೊಸತನವನ್ನು ತರಲು, ವಿಸ್ತರಿಸಲು ಮತ್ತು ಅಭಿವೃದ್ಧಿ ಹೊಂದಲು ನಾವು ಸಮರ್ಪಿತರಾಗಿದ್ದೇವೆ.",
        visionBullet1: "ಪ್ರತಿ ಪ್ರಮಾಣಕ್ಕೂ AI-ಮೊದಲ ಪರಿಹಾರಗಳು",
        visionBullet2: "ಭಾರತದ ಡಿಜಿಟಲ್ ವಿಭಜನೆಯನ್ನು ಸೇತುವೆ ಮಾಡುವುದು",
        visionBullet3: "ಮುಂದಿನ ಜನಾಂಗದ ಎಡ್-ಟೆಕ್ ಮತ್ತು ಫಿನ್-ಟೆಕ್ ಅನ್ನು ಮುನ್ನಡೆಸುವುದು",

        missionLabel2: "ನಮ್ಮ ಉದ್ದೇಶ",
        missionSubtitleH2: "ಮಹತ್ವಾಕಾಂಕ್ಷೆಯನ್ನು ಕಾರ್ಯಗತಗೊಳಿಸುವಿಕೆಯೊಂದಿಗೆ ಸೇರಿಸುವುದು",
        missionBody1: "ಕ್ಯಾಸ್ಕೇಡ್ ಸ್ಪೇಸ್‌ನಲ್ಲಿ, ನಮ್ಮ ಉದ್ದೇಶವು ಡಿಜಿಟಲ್ ಯುಗದ ಸಂಕೀರ್ಣತೆಗಳನ್ನು ಡಿಕೋಡ್ ಮಾಡುವುದು ಮತ್ತು ಮಾನವ ಸಾಮರ್ಥ್ಯ ಮತ್ತು ಸಾಂಸ್ಥಿಕ ಬೆಳವಣಿಗೆಯನ್ನು ವರ್ಧಿಸುವ ಸುವ್ಯವಸ್ಥಿತ, ಬುದ್ಧಿವಂತ ವ್ಯವಸ್ಥೆಗಳನ್ನು ವಿತರಿಸುವುದು.",
        missionBody2: "ನಿಜವಾದ ನಾವೀನ್ಯತೆಯು ಕೇವಲ ಇತ್ತೀಚಿನ ತಂತ್ರಜ್ಞಾನವನ್ನು ಅಳವಡಿಸಿಕೊಳ್ಳುವುದರಲ್ಲಿ ಮಾತ್ರವಲ್ಲ, ಬದಲಾಗಿ ನೈಜ-ಪ್ರಪಂಚದ ಸಮಸ್ಯೆಗಳನ್ನು ಪರಿಹರಿಸಲು ಅದನ್ನು ಪರಿಣಾಮಕಾರಿಯಾಗಿ ಅನ್ವಯಿಸುವಲ್ಲಿ ಅಡಗಿದೆ ಎಂದು ನಾವು ನಂಬುತ್ತೇವೆ. ನಾವು ನಿರ್ಮಿಸುವ ಪ್ರತಿಯೊಂದು ಉತ್ಪನ್ನವನ್ನು ಅಳೆಯಲು ಮತ್ತು ಸಹಿಸಿಕೊಳ್ಳಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ.",
        missionCardP1: "ಪ್ರಮಾಣಾನುಗುಣವಾದ ವಾಸ್ತುಶಿಲ್ಪಗಳಿಗೆ ನಿಖರವಾದ ಗಮನದೊಂದಿಗೆ ದೋಷರಹಿತವಾಗಿ ಕಾರ್ಯಗತಗೊಳಿಸಲಾಗಿದೆ.",
        missionCardP2: "ವಿಶಿಷ್ಟವಾದ ಅದ್ಭುತ ಡಿಜಿಟಲ್ ಪರಿಹಾರಗಳನ್ನು ರಚಿಸಲು ಯಥಾಸ್ಥಿತಿಗೆ ಸವಾಲು ಹಾಕುವುದು.",

        coreValuesLabel: "ಮೂಲ ಮೌಲ್ಯಗಳು",
        valDesc0: "ಆಧುನಿಕ ಟೆಕ್ ಸ್ಟಾಕ್‌ಗಳೊಂದಿಗೆ ಸಾಧ್ಯವಿರುವ ಮಿತಿಗಳನ್ನು ನಿರಂತರವಾಗಿ ತಳ್ಳುವುದು.",
        valDesc1: "ನಿಮ್ಮ ವ್ಯವಹಾರವು ವಿಸ್ತರಿಸಿದಂತೆ ಮನಬಂದಂತೆ ಬೆಳೆಯಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾದ ಆರ್ಕಿಟೆಕ್ಚರ್‌ಗಳನ್ನು ನಿರ್ಮಿಸುವುದು.",
        valDesc2: "ತಂಡಗಳು ಮತ್ತು ಗ್ರಾಹಕರು ಯಶಸ್ವಿಯಾಗಲು ಪರಿಕರಗಳನ್ನು ಹೊಂದಿರುವ ಪರಿಸರ ವ್ಯವಸ್ಥೆಯನ್ನು ಬೆಳೆಸುವುದು.",

        teamLabel: "ನಾಯಕತ್ವ",
        teamTitle: "ತಂತ್ರಜ್ಞಾನದ ಹಿಂದಿನ ಮನಸ್ಸುಗಳು",
        teamDesc: "ತನ್ನ ತೂಕದ ವರ್ಗಕ್ಕಿಂತ ಹೆಚ್ಚಿನದನ್ನು ಪಂಚ್ ಮಾಡುವ ಸಣ್ಣ, ಪಟ್ಟುಹಿಡಿದ ತಂಡ.",

        projectsLabel: "ನಮ್ಮ ಕೆಲಸ",
        projectsTitle: "ನಮ್ಮನ್ನು ವ್ಯಾಖ್ಯಾನಿಸುವ ಯೋಜನೆಗಳು",
        projectsBodyDesc: "ನಿಖರತೆಯಿಂದ ನಿರ್ಮಿಸಲಾದ ಪರಿಹಾರಗಳ ಪ್ರದರ್ಶನ — ಪ್ರತಿ ಯೋಜನೆಯು ನಮ್ಮ ಎಂಜಿನಿಯರಿಂಗ್ ಸಂಸ್ಕೃತಿಗೆ ಸಾಕ್ಷಿಯಾಗಿದೆ.",
        projectsComingSoon: "ಇನ್ನಷ್ಟು ಆವಿಷ್ಕಾರಗಳು ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿವೆ ✦",
        ctaBannerTitle: "ಅಸಾಧಾರಣವಾದದ್ದನ್ನು ನಿರ್ಮಿಸೋಣ",
        ctaBannerDesc: "ನಿಮ್ಮ ದೃಷ್ಟಿಕೋನವನ್ನು ವಿಶ್ವ ದರ್ಜೆಯ ಡಿಜಿಟಲ್ ಉತ್ಪನ್ನವಾಗಿ ಪರಿವರ್ತಿಸಲು ಕ್ಯಾಸ್ಕೇಡ್‌ಟೆಕ್ ಜೊತೆ ಪಾಲುದಾರರಾಗಿರಿ.",
    },

    // --- SERVICES ---
    services: {
        heroLabel: "ನಾವು ಏನು ಮಾಡುತ್ತೇವೆ",
        heroDesc: "ಪರಿಕಲ್ಪನೆಯಿಂದ ನಿಯೋಜನೆಯವರೆಗೆ, ನಾವು ನಿಖರವಾದ, ಕಾರ್ಯಕ್ಷಮತೆ ಮತ್ತು ಭವಿಷ್ಯಕ್ಕೆ ಸಿದ್ಧವಾದ ಪರಿಹಾರಗಳನ್ನು ರಚಿಸುತ್ತೇವೆ.",

        engagementLabel: "ನಮ್ಮ ಎಂಗೇಜ್‌ಮೆಂಟ್ ಮಾಡೆಲ್",
        engagementTitle: "ಕಲ್ಪನೆಯಿಂದ ಪ್ರಭಾವಕ್ಕೆ ಸಾಬೀತಾದ ಹಾದಿ",
        engagementBody: "ನಾವು ಅಸ್ಪಷ್ಟತೆಯನ್ನು ತೆಗೆದುಹಾಕುವ ಮತ್ತು ಪ್ರತಿ ಯೋಜನೆಯನ್ನು ಸಮಯಕ್ಕೆ, ವ್ಯಾಪ್ತಿಯೊಳಗೆ ಮತ್ತು ನಿರೀಕ್ಷೆಗಳನ್ನು ಮೀರಿ ತಲುಪಿಸುವುದನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳುವ ರಚನಾತ್ಮಕ ನಿಶ್ಚಿತಾರ್ಥದ ಮಾದರಿಯನ್ನು ಅನುಸರಿಸುತ್ತೇವೆ.",

        catDTTitle: "ಡಿಜಿಟಲ್ ರೂಪಾಂತರ",
        catDTDesc: "ಸಮಗ್ರ ಡಿಜಿಟಲ್ ಕೂಲಂಕಷ ಪರೀಕ್ಷೆಗಳ ಮೂಲಕ ನಾವು ಸಂಸ್ಥೆಗಳಿಗೆ ಮಾರ್ಗದರ್ಶನ ನೀಡುತ್ತೇವೆ, ಪರಂಪರೆ ವ್ಯವಸ್ಥೆಗಳನ್ನು ಆಧುನಿಕ, ಸ್ಕೇಲೆಬಲ್ ಆರ್ಕಿಟೆಕ್ಚರ್‌ಗಳಿಗೆ ಸ್ಥಳಾಂತರಿಸುತ್ತೇವೆ ಅದು ದಕ್ಷತೆಯನ್ನು ಸುಧಾರಿಸುತ್ತದೆ ಮತ್ತು ಕಾರ್ಯಾಚರಣೆಯ ಓವರ್‌ಹೆಡ್ ಅನ್ನು ಕಡಿಮೆ ಮಾಡುತ್ತದೆ.",
        catDTF1: "ಎಂಟರ್‌ಪ್ರೈಸ್ ಆರ್ಕಿಟೆಕ್ಚರ್ ವಲಸೆ",
        catDTF2: "ಕ್ಲೌಡ್ ಇನ್ಫ್ರಾಸ್ಟ್ರಕ್ಚರ್ ಸೆಟಪ್ ಮತ್ತು ಆಪ್ಟಿಮೈಸೇಶನ್",
        catDTF3: "ಪರಂಪರೆ ವ್ಯವಸ್ಥೆ ಆಧುನೀಕರಣ",
        catDTF4: "ವರ್ಕ್‌ಫ್ಲೋ ಆಟೊಮೇಷನ್",

        catAITitle: "AI ಮತ್ತು ಸ್ಮಾರ್ಟ್ ಪರಿಹಾರಗಳು",
        catAIDesc: "ಸಂಕೀರ್ಣ ಕಾರ್ಯಗಳನ್ನು ಸ್ವಯಂಚಾಲಿತಗೊಳಿಸಲು, ಮುನ್ಸೂಚಕ ಒಳನೋಟಗಳನ್ನು ರಚಿಸಲು ಮತ್ತು ಪ್ರಮಾಣದಲ್ಲಿ ವೈಯಕ್ತೀಕರಿಸಿದ ಅನುಭವಗಳನ್ನು ರಚಿಸಲು ಕೃತಕ ಬುದ್ಧಿಮತ್ತೆಯ ಶಕ್ತಿಯನ್ನು ಬಳಸಿಕೊಳ್ಳಿ.",
        catAIF1: "ಕಸ್ಟಮ್ ಎಲ್ಎಲ್ಎಂ ಏಕೀಕರಣ ಮತ್ತು ಫೈನ್-ಟ್ಯೂನಿಂಗ್",
        catAIF2: "ಸಂಭಾಷಣಾ AI ಮತ್ತು ಚಾಟ್‌ಬಾಟ್‌ಗಳು",
        catAIF3: "ಮುನ್ಸೂಚಕ ಡೇಟಾ ಅನಾಲಿಟಿಕ್ಸ್",
        catAIF4: "ಬುದ್ಧಿವಂತ ಪ್ರಕ್ರಿಯೆ ಯಾಂತ್ರೀಕರಣ",

        catDBTitle: "ವಿನ್ಯಾಸ ಮತ್ತು ಬ್ರಾಂಡಿಂಗ್",
        catDBDesc: "ನಿಮ್ಮ ಡಿಜಿಟಲ್ ಉಪಸ್ಥಿತಿಯು ನಿಮ್ಮ ಮಹತ್ವಾಕಾಂಕ್ಷೆಯನ್ನು ಪ್ರತಿಬಿಂಬಿಸಬೇಕು. ನಾವು ನಿಮ್ಮ ಗುರಿ ಪ್ರೇಕ್ಷಕರೊಂದಿಗೆ ಪ್ರತಿಧ್ವನಿಸುವ ಪ್ರೀಮಿಯಂ, ಬಳಕೆದಾರ-ಕೇಂದ್ರಿತ ಇಂಟರ್ಫೇಸ್ಗಳು ಮತ್ತು ಬ್ರ್ಯಾಂಡ್ ಗುರುತುಗಳನ್ನು ರಚಿಸುತ್ತೇವೆ.",
        catDBF1: "ಬಳಕೆದಾರ ಇಂಟರ್ಫೇಸ್ (UI) ವಿನ್ಯಾಸ",
        catDBF2: "ಬಳಕೆದಾರ ಅನುಭವ (UX) ಸಂಶೋಧನೆ",
        catDBF3: "ಬ್ರಾಂಡ್ ಐಡೆಂಟಿಟಿ ಮತ್ತು ಸ್ಟ್ರಾಟಜಿ",
        catDBF4: "ಸಂವಾದಾತ್ಮಕ ಮೂಲಮಾದರಿಗಳು",

        ctaBannerTitle: "ನಿಮ್ಮ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಅನ್ನು ನಿರ್ಮಿಸಲು ಸಿದ್ಧರಿದ್ದೀರಾ?",
        ctaBannerDesc: "ನಿಮಗೆ ಸಂಪೂರ್ಣ ಡಿಜಿಟಲ್ ರೂಪಾಂತರ ಅಥವಾ ನಿರ್ದಿಷ್ಟ AI ಮಾಡ್ಯೂಲ್ ಅಗತ್ಯವಿದೆಯೇ, ನಮ್ಮ ತಂಡ ಕಾರ್ಯಗತಗೊಳಿಸಲು ಸಿದ್ಧವಾಗಿದೆ.",

        cta: "ಉಚಿತ ಸಮಾಲೋಚನೆ ಪಡೆಯಿರಿ",
        discussService: "ಈ ಸೇವೆಯ ಕುರಿತು ಚರ್ಚಿಸಿ",
    },

    // --- CONTACT ---
    contact: {
        heroLabel: "ಸಂಪರ್ಕದಲ್ಲಿರಿ",
        heroTitle: "ಒಟ್ಟಿಗೆ ಗ್ರೇಟ್ ಆದದ್ದನ್ನು ನಿರ್ಮಿಸೋಣ",
        contactBody: "ಮನಸ್ಸಿನಲ್ಲಿ ಯೋಜನೆಯನ್ನು ಹೊಂದಿದ್ದೀರಾ ಅಥವಾ ನಮ್ಮ ಸೇವೆಗಳ ಬಗ್ಗೆ ಪ್ರಶ್ನೆಗಳಿವೆಯೇ? ನಿಮ್ಮಿಂದ ಕೇಳಲು ನಾವು ಇಷ್ಟಪಡುತ್ತೇವೆ.",

        name: "ನಿಮ್ಮ ಹೆಸರು",
        email: "ಈಮೇಲ್ ವಿಳಾಸ",
        message: "ನಿಮ್ಮ ಸಂದೇಶ",
        send: "ಸಂದೇಶ ಕಳುಹಿಸಿ",

        formResponseTime: "ನಾವು 24-48 ಗಂಟೆಗಳ ಒಳಗೆ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತೇವೆ.",
        businessHours: "ಸೋಮವಾರ–ಶುಕ್ರವಾರ, 9am–5pm IST",
        hqTitle: "ಕ್ಯಾಸ್ಕೇಡ್‌ಟೆಕ್ ಸೊಲ್ಯೂಷನ್ಸ್ ಮುಖ್ಯ ಕಛೇರಿ",
        hqLocation: "ವಿದ್ಯಾ-ನಗರ, ಹುಬ್ಬಳ್ಳಿ",
    },

    // --- PROJECTS PAGE ---
    projectsPage: {
        heroLabel: "ಪೋರ್ಟ್‌ಫೋಲಿಯೊ ಹಾಗೂ ಕೇಸ್ ಸ್ಟಡೀಸ್",
        heroDesc: "ನೈಜ-ಪ್ರಪಂಚದ ಸಮಸ್ಯೆಗಳನ್ನು ಪರಿಹರಿಸಲು ಮತ್ತು ವ್ಯಾವಸಾಯಿಕ ಬೆಳವಣಿಗೆಯನ್ನು ವೇಗಗೊಳಿಸಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾದ ನಮ್ಮ ಡಿಜಿಟಲ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ಗಳು ಮತ್ತು ಪರಿಕರಗಳ ಪೋರ್ಟ್‌ಫೋಲಿಯೊವನ್ನು ಅನ್ವೇಷಿಸಿ.",

        startopiaTitle: "ಸ್ಟಾರ್ಟೋಪಿಯಾ",
        startopiaDesc: "ಸಂಪನ್ಮೂಲಗಳು, ಹೂಡಿಕೆದಾರರ ಸಂಪರ್ಕಗಳು ಮತ್ತು ಹೆಚ್ಚು ಸ್ಕೇಲೆಬಲ್ ತಾಂತ್ರಿಕ ವೇದಿಕೆಗಳೊಂದಿಗೆ ಸಂಸ್ಥಾಪಕರನ್ನು ಸಬಲೀಕರಣಗೊಳಿಸುವ ಸಮಗ್ರ ವ್ಯವಸ್ಥೆಯಾಗಿ ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ.",
        startopiaFeat1: "ಎಂಡ್-ಟು-ಎಂಡ್ ಎನ್‌ಕ್ರಿಪ್ಶನ್",
        startopiaFeat2: "ಸ್ವಯಂಚಾಲಿತ ಮ್ಯಾಚ್‌ಮೇಕಿಂಗ್",
        startopiaFeat3: "ನೈಜ-ಸಮಯದ ವಿಶ್ಲೇಷಣೆಗಳು",
        startopiaFeat4: "ಸ್ಕೇಲೆಬಲ್ ಮೈಕ್ರೋ-ಸರ್ವಿಸಸ್",
        startopiaPreview: "ಸ್ಟಾರ್ಟೋಪಿಯಾ প্রিவியೂ",

        textYourBossTitle: "ಟೆಕ್ಸ್ಟ್ ಯುವರ್ ಬಾಸ್.ಎಐ",
        textYourBossDesc: "ಎಂಟರ್‌ಪ್ರೈಸ್ ತಂಡಗಳಿಗಾಗಿ ವೃತ್ತಿಪರ ಮೆಸೇಜಿಂಗ್, ವರ್ಕ್‌ಫ್ಲೋ ಆಟೋಮೇಷನ್ ಮತ್ತು ಸಂದರ್ಭ-ಹೊಂದಿಕೆಯ ಪ್ರತಿಕ್ರಿಯೆಗಳನ್ನು ಸರಳಗೊಳಿಸುವ AI-ಚಾಲಿತ ಸಂವಹನ ಸಾಧನ.",
        textYourBossFeat1: "ಸಂದರ್ಭ-ಆಧಾರಿತ AI ಉತ್ಪಾದನೆ",
        textYourBossFeat2: "ಟೋನ್ ಹೊಂದಾಣಿಕೆ ಎಂಜಿನ್",
        textYourBossFeat3: "ಮಲ್ಟಿ-ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಇಂಟಿಗ್ರೇಶನ್",
        textYourBossFeat4: "ಎಂಟರ್‌ಪ್ರೈಸ್ ರೋಲ್-ಬೇಸ್ಡ್ ಆಕ್ಸೆಸ್",
        textYourBossPreview: "ಟೆಕ್ಸ್ಟ್ ಯುವರ್ ಬಾಸ್.ಎಐ ಇಂಟರ್‌ಫೇಸ್",

        comingSoonLabel: "ಆವಿಷ್ಕಾರಗಳ ಪೈಪ್‌ಲೈನ್",
        futureProj1Title: "ನವೀಕರಿಸಬಹುದಾದ ಇಂಧನ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್",
        futureProj1Desc: "ಸೌರ ಮತ್ತು ಗಾಳಿ ಶಕ್ತಿ ಪಾರ್ಮ್‌ಗಳ ಸಾಧನೆಯನ್ನು ನೈಜ ಸಮಯದಲ್ಲಿ ನಿರ್ವಹಿಸುವ ಮತ್ತು ಆಪ್ಟಿಮೈಸ್ ಮಾಡುವ IoT-ಸಕ್ರಿಯಗೊಳಿಸಿದ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್.",
        futureProj1Status: "ಅಭಿವೃದ್ಧಿಯ ಹಂತದಲ್ಲಿದೆ",

        futureProj2Title: "ಅಲ್ಗಾರಿದಮಿಕ್ ಟ್ರೇಡಿಂಗ್ ಬಾಟ್",
        futureProj2Desc: "ಸಂಕೀರ್ಣ ಹಣಕಾಸು ತಂತ್ರಗಳನ್ನು ಕಾರ್ಯಗತಗೊಳಿಸಲು ಮೆಷಿನ್ ಲರ್ನಿಂಗ್ ಬಳಸುವ ಹೈ-ಫ್ರೀಕ್ವೆನ್ಸಿ ಟ್ರೇಡಿಂಗ್ ಅಲ್ಗಾರಿದಮ್.",
        futureProj2Status: "ಬೀಟಾ ಟೆಸ್ಟಿಂಗ್ ಹಂತದಲ್ಲಿದೆ",

        futureProj3Title: "ಸ್ವಾಯತ್ತ ರೊಬೊಟಿಕ್ಸ್ API",
        futureProj3Desc: "ವೈವಿಧ್ಯಮಯ ಕೈಗಾರಿಕಾ ರೊಬೊಟಿಕ್ಸ್ ವ್ಯವಸ್ಥೆಗಳ ನಡುವೆ ಸುಗಮ ಸಂಯೋಜನೆಯನ್ನು ಸಕ್ರಿಯಗೊಳಿಸುವ ಮಾನದಂಡಿತ ಸಂವಹನ API.",
        futureProj3Status: "ಸಂಶೋಧನಾ ಹಂತ",

        ctaBannerTitle: "ಮನಸ್ಸಿನಲ್ಲಿ ಪ್ರಾಜೆಕ್ಟ್ ಇದೆಯೇ?",
        ctaBannerDesc: "ನಿಮ್ಮ ಉದ್ಯಮದ ಮಿತಿಗಳನ್ನು ಮೀರುವಂತಹ ಅಸಾಧಾರಣವಾದದ್ದನ್ನು ನಿರ್ಮಿಸಲು ಒಟ್ಟಾಗಿ ಕೆಲಸ ಮಾಡೋಣ.",
    },

    // --- TEAM PAGE ---
    teamPage: {
        heroLabel: "ನಮ್ಮ ನಾಯಕತ್ವ",
        heroDesc: "ವ್ಯಾಪಾರದ ಬೆಳವಣಿಗೆ ಮತ್ತು ನಾವೀನ್ಯತೆಗಾಗಿ ತಂತ್ರಜ್ಞಾನವನ್ನು ಬಳಸುವ ವಿಧಾನವನ್ನು ಬದಲಾಯಿಸುತ್ತಿರುವ ನಮ್ಮ ದಾರ್ಶನಿಕ ನಾಯಕರನ್ನು ಭೇಟಿ ಮಾಡಿ.",

        akshayBio: "ಅಕ್ಷಯ್ ಕುಮಾರ್ ಅಂಕಲಗಿ ಅವರು ಕ್ಯಾಸ್ಕೇಡ್-ಟೆಕ್ ಸೊಲ್ಯೂಷನ್ಸ್‌ನ ದೂರದೃಷ್ಟಿಯುಳ್ಳ CEO ಆಗಿದ್ದಾರೆ, ತಂತ್ರಜ್ಞಾನ ನಾಯಕತ್ವ ಮತ್ತು ವ್ಯವಹಾರ ರೂಪಾಂತರದಲ್ಲಿ ಅಪಾರ ಅನುಭವವನ್ನು ಹೊಂದಿದ್ದಾರೆ. ಅವರ ಕಾರ್ಯತಂತ್ರದ ಒಳನೋಟಗಳು ಮತ್ತು ಮುಂದಾಲೋಚನೆಯ ವಿಧಾನವು ಕ್ಯಾಸ್ಕೇಡ್-ಟೆಕ್ ಅನ್ನು ಡಿಜಿಟಲ್ ನಾವೀನ್ಯತೆಯಲ್ಲಿ ಮುಂಚೂಣಿಯಲ್ಲಿ ಇರಿಸಿದೆ. ಉದ್ಯಮಗಳಾದ್ಯಂತ ಗ್ರಾಹಕರಿಗೆ ಶಾಶ್ವತ ಮೌಲ್ಯವನ್ನು ಸೃಷ್ಟಿಸುವ ಮಾರುಕಟ್ಟೆ ಅವಕಾಶಗಳನ್ನು ಗುರುತಿಸುವಲ್ಲಿ ಮತ್ತು ಪರಿಹಾರಗಳನ್ನು ಅಭಿವೃದ್ಧಿಪಡಿಸುವಲ್ಲಿ ಅಕ್ಷಯ್ ಪರಿಣತಿ ಹೊಂದಿದ್ದಾರೆ.",
        manojBio: "ಮನೋಜ್ ರೇಲೇಕರ್ ಅವರು ಕ್ಯಾಸ್ಕೇಡ್-ಟೆಕ್ ಸೊಲ್ಯೂಷನ್ಸ್‌ನ ಕಾರ್ಯಚರಣಾ ಬೆನ್ನೆಲುಬಾಗಿ ಸೇವೆ ಸಲ್ಲಿಸುತ್ತಿದ್ದಾರೆ, ಅಸಾಧಾರಣ ಸಾಂಸ್ಥಿಕ ನಾಯಕತ್ವ ಮತ್ತು ಪ್ರಕ್ರಿಯೆ ಆಪ್ಟಿಮೈಸೇಶನ್ ಪರಿಣತಿಯನ್ನು ತರುತ್ತಾರೆ. ತಂತ್ರಜ್ಞಾನ ಮತ್ತು ವ್ಯವಹಾರ ಕಾರ್ಯಾಚರಣೆಗಳಲ್ಲಿ ಹಿನ್ನೆಲೆಯೊಂದಿಗೆ, ನಮ್ಮ ಸೇವಾ ವಿತರಣೆಯು ಯಾವಾಗಲೂ ಕ್ಲೈಂಟ್ ನಿರೀಕ್ಷೆಗಳನ್ನು ಮೀರುತ್ತದೆ ಎಂದು ಮನೋಜ್ ಖಚಿತಪಡಿಸಿಕೊಳ್ಳುತ್ತಾರೆ. ಕಾರ್ಯಾಚರಣೆಗಳನ್ನು ಅಳೆಯುವ ಅವರ ಕ್ರಮಬದ್ಧ ವಿಧಾನ ಕ್ಯಾಸ್ಕೇಡ್-ಟೆಕ್‌ನ ಸುಸ್ಥಿರ ಬೆಳವಣಿಗೆಗೆ ಪ್ರಮುಖವಾಗಿದೆ.",
        vaibhavaBio: "ವೈಭವ ಬಿ.ಜಿ ಕ್ಯಾಸ್ಕೇಡ್-ಟೆಕ್‌ನ ತಾಂತ್ರಿಕ ನಾವೀನ್ಯತೆಯನ್ನು CTO ಆಗಿ ಮುನ್ನಡೆಸುತ್ತಿದ್ದಾರೆ, ಆಳವಾದ ತಾಂತ್ರಿಕ ಪರಿಣತಿಯನ್ನು ಸೃಜನಶೀಲ ಸಮಸ್ಯೆ-ಪರಿಹರಿಸುವ ಸಾಮರ್ಥ್ಯಗಳೊಂದಿಗೆ ಸಂಯೋಜಿಸುತ್ತಿದ್ದಾರೆ. AI, ಬ್ಲಾಕ್‌ಚೈನ್ ಮತ್ತು ಕ್ಲೌಡ್ ಆರ್ಕಿಟೆಕ್ಚರ್ ನಂತಹ ಉದಯೋನ್ಮುಖ ತಂತ್ರಜ್ಞಾನಗಳ ಮೇಲಿನ ಅವರ ಉತ್ಸಾಹವು ನಮ್ಮ ಉತ್ಪನ್ನ ಅಭಿವೃದ್ಧಿ ಮಾರ್ಗಸೂಚಿಯನ್ನು ಚಾಲನೆ ಮಾಡುತ್ತದೆ. ಸ್ಕೇಲೆಬಲ್, ಸುರಕ್ಷಿತ ಡಿಜಿಟಲ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ಗಳನ್ನು ನಿರ್ಮಿಸುವಲ್ಲಿ ವೈಭವ ಅವರ ನಾಯಕತ್ವವು ನಮ್ಮ ಗ್ರಾಹಕರ ಅತ್ಯಂತ ಸಂಕೀರ್ಣ ಸವಾಲುಗಳಿಗೆ ಪರಿವರ್ತನಾತ್ಮಕ ಪರಿಹಾರಗಳನ್ನು ಒದಗಿಸುವಲ್ಲಿ ನಿರ್ಣಾಯಕವಾಗಿದೆ.",

        coreValuesLabel: "ನಮ್ಮ ತತ್ವಗಳು",
        coreValuesTitle: "ನಮ್ಮನ್ನು ಲಂಗರು ಹಾಕುವ ಆದರ್ಶಗಳು",
        valInnovationDesc: "ಹೊಸ ತಂತ್ರಜ್ಞಾನಗಳು ಮತ್ತು ವಿಧಾನಗಳನ್ನು ನಿರಂತರವಾಗಿ ಅನ್ವೇಷಿಸುವುದು.",
        valExcellenceDesc: "ನಿಖರತೆ ಮತ್ತು ವಿವರಗಳಿಗೆ ಗಮನ ಕೊಡುವ ಮೂಲಕ ನಿರೀಕ್ಷೆಗಳನ್ನು ಮೀರುವುದು.",
        valIntegrityDesc: "ಪ್ರಾಮಾಣಿಕ, ಪಾರದರ್ಶಕ ಅಭ್ಯಾಸಗಳ ಮೂಲಕ ನಂಬಿಕೆಯನ್ನು ಬೆಳೆಸುವುದು.",
        valCollaborationDesc: "ಸಮಗ್ರ ಪರಿಹಾರಗಳಿಗಾಗಿ ವಿಭಾಗಗಳಾದ್ಯಂತ ಒಟ್ಟಾಗಿ ಕೆಲಸ ಮಾಡುವುದು.",

        ctaBannerTitle: "ನಮ್ಮ ಬೆಳೆಯುತ್ತಿರುವ ಪರಿಸರ ವ್ಯವಸ್ಥೆಗೆ ಸೇರಿ",
        ctaBannerDesc: "ನಾವು ಯಾವಾಗಲೂ ಸಹಯೋಗಗೊಳ್ಳಲು ದೂರದೃಷ್ಟಿಯುಳ್ಳ ಗ್ರಾಹಕರು ಮತ್ತು ಅದ್ಭುತ ಮನಸ್ಸುಗಳಿಗಾಗಿ ಹುಡುಕುತ್ತಿದ್ದೇವೆ.",
    },

    // --- NOT FOUND ---
    notFound: {
        title: "ಸಿಸ್ಟಮ್ ನೋಡ್ ಕಂಡುಬಂದಿಲ್ಲ",
        desc: "ನೀವು ವಿನಂತಿಸಿದ ಪಥವು ನಮ್ಮ ಡಿಜಿಟಲ್ ಮೂಲಸೌಕರ್ಯದಲ್ಲಿ ಅಸ್ತಿತ್ವದಲ್ಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಕೋರ್ ಮಾಡ್ಯೂಲ್‌ಗೆ ಹಿಂತಿರುಗಿ.",
        backToHome: "ಕೋರ್ ಅನುಕ್ರಮವನ್ನು ಪ್ರಾರಂಭಿಸಿ",
    },

    // --- FOOTER ---
    footer: {
        desc: "ವೆಬ್ ವಿನ್ಯಾಸ, ಸಾಫ್ಟ್‌ವೇರ್ ಅಭಿವೃದ್ಧಿ ಮತ್ತು ಬುದ್ಧಿವಂತ ಡಿಜಿಟಲ್ ಪರಿಹಾರಗಳಲ್ಲಿ ಪರಿಣತಿ ಹೊಂದಿರುವ ಅತ್ಯಾಧುನಿಕ ತಂತ್ರಜ್ಞಾನದ ಮೂಲಕ ವ್ಯವಹಾರಗಳನ್ನು ಸಬಲೀಕರಣಗೊಳಿಸುವುದು.",
        company: "ಕಂಪನಿ",
        services: "ಸೇವೆಗಳು",
        contact: "ಸಂಪರ್ಕ",
        rights: "ಕ್ಯಾಸ್ಕೇಡ್-ಟೆಕ್ ಪರಿಹಾರಗಳು. ಎಲ್ಲ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
        tagline: "ನಿಖರತೆಯೊಂದಿಗೆ ನಿರ್ಮಿಸಲಾಗಿದೆ · ಪ್ರಮಾಣಕ್ಕೆ ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ",
    },

    // --- GENERIC CTA ---
    cta: {
        startProject: "ನಿಮ್ಮ ಯೋಜನೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ",
        learnMore: "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",
        getInTouch: "ಸಂಪರ್ಕದಲ್ಲಿರಿ",
    },

    // --- HEADINGS SUPPLEMENT ---
    headings: {
        techTitle: "ನಮ್ಮ ಸೇವೆಗಳನ್ನು ಕ್ರಿಯೆಯಲ್ಲಿ ನೋಡಿ",
        emailUs: "ನಮಗೆ ಇಮೇಲ್ ಮಾಡಿ",
        visitUs: "ನಮ್ಮನ್ನು ಭೇಟಿ ಮಾಡಿ",
        infoEmail: "ಇಮೇಲ್",
        infoPhone: "ದೂರವಾಣಿ",
        infoAddress: "ವಿಳಾಸ",
        infoHours: "ಕೆಲಸದ ಸಮಯ",
        formTitle: "ನಮಗೆ ಸಂದೇಶ ಕಳುಹಿಸಿ",
        missionSubtitle: "ಎಕ್ಸಿಕ್ಯೂಶನ್ ಜೊತೆಗೆ ಮಹತ್ವಾಕಾಂಕ್ಷೆಯನ್ನು ಬೆಸೆಯುವುದು",
        valPrecision: "ನಿಖರತೆ",
        valInnovation: "ಆವಿಷ್ಕಾರ",
        valExcellence: "ಉತ್ಕೃಷ್ಟತೆ",
        valIntegrity: "ಸಮಗ್ರತೆ",
        valCollaboration: "ಸಹಯೋಗ",
        visionSubtitle: "ನಾಳೆಯ ಆರ್ಕಿಟೆಕ್ಚರಿಂಗ್",
        projectsHeroTitle: "ಫಲಿತಾಂಶಗಳನ್ನು ನೀಡುವ ನವೀನ ಪರಿಹಾರಗಳು",
        teamHeroTitle: "ಕ್ಯಾಸ್ಕೇಡ್‌ಟೆಕ್ ಸೊಲ್ಯೂಷನ್ಸ್ ಹಿಂದಿರುವ ತಂಡ",
        ctaBannerTitle: "ನಿಮ್ಮ ಡಿಜಿಟಲ್ ಉಪಸ್ಥಿತಿಯನ್ನು ಪರಿವರ್ತಿಸಲು ಸಿದ್ಧರಿದ್ದೀರಾ?",
        comingSoon: "ಬಿಡುಗಡೆಗೆ ಸಿದ್ಧತೆ",
        servicesHeroH1: "ಆಧುನಿಕ ಎಂಟರ್‌ಪ್ರೈಸ್‌ಗಾಗಿ ಬುದ್ಧಿವಂತ ಪರಿಹಾರಗಳು",
        discussService: "ಈ ಸೇವೆಯನ್ನು ಚರ್ಚಿಸಿ",
        viewCaseStudy: "ಕೇಸ್ ಸ್ಟಡಿ ವೀಕ್ಷಿಸಿ",
        valuesSectionTitle: "ಯಾವುದು ನಮ್ಮನ್ನು ಮುಂದಕ್ಕೆ ಕೊಂಡೊಯ್ಯುತ್ತದೆ",
        builtOnPrinciple: "ತತ್ವದ ಮೇಲೆ ನಿರ್ಮಿಸಲಾಗಿದೆ",
        mindsBehinTech: "ತಂತ್ರಜ್ಞಾನದ ಹಿಂದಿನ ಮನಸ್ಸುಗಳು",
        contactHeroTitle: "ಒಟ್ಟಿಗೆ ಅದ್ಭುತವನ್ನು ನಿರ್ಮಿಸೋಣ",
        intelligence: "ಬುದ್ಧಿಮತ್ತೆ",
        missionPillarSpeed: "ವೇಗ",
        missionPillarReliability: "ವಿಶ್ವಾಸಾರ್ಹತೆ",
        missionPillarReach: "ತಲುಪುವಿಕೆ",
        missionPillarIntelligence: "ಬುದ್ಧಿಮತ್ತೆ",
        futureVisionBody: "ನಾವು ತಂತ್ರಜ್ಞಾನದ ತತ್ಕಾಲಿಕ ನಿರ್ಬಂಧಗಳನ್ನು ಮೀರಿ ನೋಡುತ್ತೇವೆ. AI ಪರಿಸರ ವ್ಯವಸ್ಥೆಗಳು, ಸ್ಮಾರ್ಟ್ ಆಟೊಮೇಷನ್ ಮತ್ತು ನವೀಕರಿಸಬಹುದಾದ ತಂತ್ರಜ್ಞಾನ ಪರಿಹಾರಗಳಲ್ಲಿ ಹೂಡಿಕೆ ಮಾಡುವ ಮೂಲಕ, ಕ್ಯಾಸ್ಕೇಡ್ ಸ್ಪೇಸ್ ಡಿಜಿಟಲ್ ಬೆಳವಣಿಗೆಯ ಮುಂದಿನ ದಶಕವನ್ನು ರೂಪಿಸುವ ಸುಸ್ಥಿರ ಮೂಲಸೌಕರ್ಯವನ್ನು ನಿರ್ಮಿಸಲು ಬದ್ಧವಾಗಿದೆ.",
        futureVisionCta: "ನಮ್ಮ ಮುಂಬರುವ ನಾವೀನ್ಯತೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
    },

    // --- BODY TEXT ---
    body: {
        labelName: "ಹೆಸರು",
        labelEmail: "ಇಮೇಲ್",
        labelCompany: "ಕಂಪನಿ",
        labelMessage: "ಸಂದೇಶ",
        optional: "(ಐಚ್ಛಿಕ)",
        placeholderName: "ನಿಮ್ಮ ಹೆಸರು",
        placeholderEmail: "john@company.com",
        placeholderCompany: "ನಿಮ್ಮ ಸಂಸ್ಥೆ",
        placeholderMessage: "ನಿಮ್ಮ ಯೋಜನೆಯ ಬಗ್ಗೆ ನಮಗೆ ತಿಳಿಸಿ ಅಥವಾ ನಮಗೆ ಏನನ್ನಾದರೂ ಕೇಳಿ...",
        formSubDesc: "ಕೆಳಗಿನ ಫಾರ್ಮ್ ಅನ್ನು ಭರ್ತಿ ಮಾಡಿ ಮತ್ತು ನಾವು ಆದಷ್ಟು ಬೇಗ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತೇವೆ.",
        contactDesc: "ಮನಸ್ಸಿನಲ್ಲಿ ಯೋಜನೆಯನ್ನು ಹೊಂದಿದ್ದೀರಾ ಅಥವಾ ನಮ್ಮ ಸೇವೆಗಳ ಬಗ್ಗೆ ಪ್ರಶ್ನೆಗಳಿವೆಯೇ? ನಿಮ್ಮಿಂದ ಕೇಳಲು ನಾವು ಇಷ್ಟಪಡುತ್ತೇವೆ.",
        contactTeamReady: "ನೀವು ನಿರ್ದಿಷ್ಟ ಯೋಜನೆಯನ್ನು ಹೊಂದಿದ್ದರೂ ಅಥವಾ ಕಾರ್ಯತಂತ್ರದ ಮಾರ್ಗದರ್ಶನದ ಅಗತ್ಯವಿದ್ದರೂ, ನಮ್ಮ ತಂಡವು ಸಿದ್ಧವಾಗಿದೆ.",
        callUs: "ನಮಗೆ ಕರೆ ಮಾಡಿ",
        visionBody: "ಭಾರತ ಮತ್ತು ಅದರಾಚೆಗಿನ ವ್ಯವಹಾರಗಳಿಗೆ ಅತ್ಯಂತ ವಿಶ್ವಾಸಾರ್ಹ ತಂತ್ರಜ್ಞಾನ ಪಾಲುದಾರರಾಗಲು — ಬುದ್ಧಿವಂತ, ಪ್ರವೇಶಿಸಬಹುದಾದ ಡಿಜಿಟಲ್ ಪರಿಸರ ವ್ಯವಸ್ಥೆಗಳನ್ನು ನಿರ್ಮಿಸುವುದು.",
        missionBody: "ಡಿಜಿಟಲ್ ಯುಗದ ಸಂಕೀರ್ಣತೆಗಳನ್ನು ಡಿಕೋಡ್ ಮಾಡುವುದು ಮತ್ತು ಮಾನವ ಸಾಮರ್ಥ್ಯವನ್ನು ವರ್ಧಿಸುವ ಸುವ್ಯವಸ್ಥಿತ, ಬುದ್ಧಿವಂತ ವ್ಯವಸ್ಥೆಗಳನ್ನು ವಿತರಿಸುವುದು.",
        visionBullet1: "ಪ್ರಮಾಣ-ಅಗತ್ಯದ AI-ಆಧಾರಿತ ಪರಿಹಾರಗಳು",
        visionBullet2: "ಭಾರತದ ಡಿಜಿಟಲ್ ವಿಭಜನೆಯನ್ನು ಸೇತುವೆ ಮಾಡುವುದು",
        visionBullet3: "ಮುಂದಿನ ಪೀಳಿಗೆಯ ಎಡ್‌ಟೆಕ್ ಮತ್ತು ಫಿನ್‌ಟೆಕ್ ಅನ್ನು ಮುನ್ನಡೆಸುತ್ತಿರುವುದು",
        teamSmallDesc: "ತನ್ನ ಸಾಮರ್ಥ್ಯಕ್ಕಿಂತಲೂ ಹೆಚ್ಚಿನದನ್ನು ಸಾಧಿಸುವ ಸಣ್ಣ ಹಾಗೂ ದೃಢವಾದ ತಂಡ.",
        meetFullTeam: "ಸಂಪೂರ್ಣ ತಂಡವನ್ನು ಭೇಟಿಯಾಗಿ",
        projectsComingSoon: "ಹೆಚ್ಚಿನ ನಾವೀನ್ಯತೆಗಳು ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿವೆ ✦",
        keyFeatures: "ಪ್ರಮುಖ ವೈಶಿಷ್ಟ್ಯಗಳು",
        heroTeamDesc: "ತಂತ್ರಜ್ಞಾನದ ಮೂಲಕ ವ್ಯವಹಾರಗಳನ್ನು ಪರಿವರ್ತಿಸಲು ಬದ್ಧರಾಗಿರುವ ಭಾವೋದ್ರಿಕ್ತ ನಾಯಕರು.",
        exploreExpertise: "ನಮ್ಮ ಪರಿಣತಿಯನ್ನು ಅನ್ವೇಷಿಸಿ",
        engageConsultants: "ನಮ್ಮ ಸಲಹೆಗಾರರನ್ನು ಸಂಪರ್ಕಿಸಿ",
        sendMessage: "ಸಂದೇಶ ಕಳುಹಿಸಿ",
        ourPurpose: "ನಮ್ಮ ಉದ್ದೇಶ",
        coreValues: "ಮೂಲ ಮೌಲ್ಯಗಳು",
        viewPortfolio: "ಪೂರ್ಣ ಪೋರ್ಟ್‌ಫೋಲಿಯೊವನ್ನು ವೀಕ್ಷಿಸಿ",
        showcaseDesc: "ನಿಖರತೆಯೊಂದಿಗೆ ನಿರ್ಮಿಸಲಾದ ಪರಿಹಾರಗಳ ಪ್ರದರ್ಶನ — ಪ್ರತಿಯೊಂದು ಯೋಜನೆಯು ನಮ್ಮ ಎಂಜಿನಿಯರಿಂಗ್ ಸಂಸ್ಕೃತಿಯ ಸಂಕೇತ.",
        footerSvcWebDev: "ವೆಬ್ಸೈಟ್ ಅಭಿವೃದ್ಧಿ",
        footerSvcWebDesign: "ವೆಬ್ ವಿನ್ಯಾಸ ಮತ್ತು UI/UX",
        footerSvcSoftDev: "ಸಾಫ್ಟ್‌ವೇರ್ ಅಭಿವೃದ್ಧಿ",
        footerSvcAI: "AI ಮತ್ತು ಚಾಟ್‌ಬಾಟ್ ಅಭಿವೃದ್ಧಿ",
        footerSvcEdTech: "ಶೈಕ್ಷಣಿಕ ತಂತ್ರಜ್ಞಾನ",
        footerSvcLoyalty: "ಲಾಯಲ್ಟಿ ಕಾರ್ಯಕ್ರಮ ಪರಿಹಾರಗಳು",

        techBridgeBen1: "ಕೊನೆಯಿಂದ ಕೊನೆಯವರೆಗೆ ಡಿಜಿಟಲ್ ರೂಪಾಂತರ",
        techBridgeBen2: "AI-ಆಧಾರಿತ ಆಟೋಮೇಷನ್ ಮತ್ತು ಒಳನೋಟಗಳು",
        techBridgeBen3: "ವಿಸ್ತರಿಸಬಹುದಾದ ಕ್ಲೌಡ್ ಆರ್ಕಿಟೆಕ್ಚರ್",
        techBridgeBen4: "ಪ್ರೀಮಿಯಂ UI/UX ವಿನ್ಯಾಸ ವ್ಯವಸ್ಥೆಗಳು",

        // HowWeWork step bodies (steps 1–4)
        hwwStepBody1: "ನಾವು ನಿಮ್ಮ ವ್ಯವಹಾರದ ಭೂದೃಶ್ಯವನ್ನು ಮ್ಯಾಪ್ ಮಾಡುವ ಮೂಲಕ ಪ್ರಾರಂಭಿಸುತ್ತೇವೆ — ನಿಮ್ಮ ಗುರಿಗಳು, ನಿರ್ಬಂಧಗಳು ಮತ್ತು ಮೇಲ್ಮೈ ಅಡಿಯಲ್ಲಿರುವ ನೈಜ ಸಮಸ್ಯೆಗಳು. ಯಾವುದೇ ಊಹೆಗಳಿಲ್ಲ, ಶಾರ್ಟ್‌ಕಟ್‌ಗಳಿಲ್ಲ.",
        hwwStepBody2: "ನಮ್ಮ ತಾಂತ್ರಿಕ ತಂಡವು ಸ್ಕೇಲೆಬಲ್ ಮತ್ತು ಭವಿಷ್ಯ-ಸಿದ್ಧ ಪರಿಹಾರ ನಕ್ಷೆಯನ್ನು ವಿನ್ಯಾಸಗೊಳಿಸುತ್ತದೆ. ಪ್ರತಿ ತಾಂತ್ರಿಕ ನಿರ್ಧಾರವು ಉದ್ದೇಶಪೂರ್ವಕ, ದಾಖಲಿಸಲ್ಪಟ್ಟ ಮತ್ತು ನಿಮ್ಮ ವ್ಯಾವಸಾಯಿಕ ಫಲಿತಾಂಶಗಳೊಂದಿಗೆ ಹೊಂದಿಸಲ್ಪಟ್ಟಿರುತ್ತದೆ.",
        hwwStepBody3: "ನಾವು ನಿರಂತರ ಫೀಡ್‌ಬ್ಯಾಕ್ ಲೂಪ್‌ಗಳೊಂದಿಗೆ ಸ್ಪ್ರಿಂಟ್‌ಗಳಲ್ಲಿ ನಿರ್ಮಿಸುತ್ತೇವೆ. ಪ್ರತಿ ಮೈಲ್‌ಸ್ಟೋನ್‌ನಲ್ಲಿ ಕಾರ್ಯನಿರ್ವಹಿಸುವ ಡೆಲಿವರಬಲ್‌ಗಳೊಂದಿಗೆ ನೀವು ಪ್ರಗತಿಯನ್ನು ನೋಡುತ್ತೀರಿ, ಕೇವಲ ಭರವಸೆಗಳಲ್ಲ.",
        hwwStepBody4: "ನಿಯೋಜನೆ ಪ್ರಾರಂಭ, ಅಂತ್ಯವಲ್ಲ. ನಾವು ನಿಮ್ಮ ವ್ಯವಹಾರ ಬೆಳೆಯುತ್ತಿದ್ದಂತೆ ಲೆಕ್ಕ-ಉಡಾವಣೆ ಬೆಂಬಲ, ಕಾರ್ಯಕ್ಷಮತೆ ಮೇಲ್ವಿಚಾರಣೆ ಮತ್ತು ಪುನರಾವರ್ತಿತ ಸುಧಾರಣೆಗಳನ್ನು ಒದಗಿಸುತ್ತೇವೆ.",

        // HowWeWork main body
        howWeWorkBody: "ನಾವು ರಚನಾತ್ಮಕ, ಪುನರಾವರ್ತಿತ ವಿಧಾನವನ್ನು ಅನುಸರಿಸುತ್ತೇವೆ — ಅನ್ವೇಷಣೆಯಿಂದ ನಿಯೋಜನೆಯವರೆಗೆ — ಪ್ರತಿ ಪರಿಹಾರವು ನಿಖರ, ಪ್ರಮಾಣಾನುಗುಣ ಮತ್ತು ಭವಿಷ್ಯಕ್ಕೆ ಸಿದ್ಧವಾಗಿದೆ ಎಂದು ಖಚಿತಪಡಿಸುತ್ತೇವೆ.",

        // Project descriptions for TechBridge section
        startopiaShortDesc: "ಸಂಸ್ಥಾಪಕರನ್ನು ಸಂಪನ್ಮೂಲಗಳು ಮತ್ತು ಸ್ಕೇಲೆಬಲ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ಗಳೊಂದಿಗೆ ಸಬಲೀಕರಣಗೊಳಿಸಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾದ ಸಮಗ್ರ ಪರಿಸರ ವ್ಯವಸ್ಥೆ.",
        textYourBossShortDesc: "ವೃತ್ತಿಪರ ಸಂದೇಶ ಕಳುಹಿಸುವಿಕೆ ಮತ್ತು ವರ್ಕ್‌ಫ್ಲೋ ಆಟೊಮೇಷನ್ ಅನ್ನು ಸರಳಗೊಳಿಸುವ AI-ಚಾಲಿತ ಸಂವಹನ ಸಾಧನ.",

        // Full project descriptions
        startopiaFullDesc: "ಸ್ಟಾರ್ಟ್‌ಅಪ್‌ಗಳನ್ನು ಹೂಡಿಕೆದಾರರು, ಮಾರ್ಗದರ್ಶಕರು ಮತ್ತು ಅಗತ್ಯ ಸೇವೆಗಳೊಂದಿಗೆ ಸಂಪರ್ಕಿಸುವ ಸಮಗ್ರ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಬೆಳವಣಿಗೆಯನ್ನು ವೇಗಗೊಳಿಸುತ್ತದೆ ಮತ್ತು ಧನಸಹಾಯವನ್ನು ಸುರಕ್ಷಿತಗೊಳಿಸುತ್ತದೆ.",
        textYourBossFullDesc: "ಉದ್ಯಮಿಗಳು ಮತ್ತು ಕಾರ್ಯನಿರ್ವಾಹಕರಿಗೆ ತತ್ಕ್ಷಣ ವ್ಯಾವಸಾಯಿಕ ಮಾರ್ಗದರ್ಶನ, ನಿರ್ಧಾರ ಬೆಂಬಲ ಮತ್ತು ಕಾರ್ಯತಂತ್ರದ ಒಳನೋಟಗಳನ್ನು ಒದಗಿಸುವ AI-ಚಾಲಿತ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್.",

        // Project tags
        tagStartupGrowth: "ಸ್ಟಾರ್ಟ್‌ಅಪ್ ಬೆಳವಣಿಗೆ",
        tagInvestorMatching: "ಹೂಡಿಕೆದಾರ ಹೊಂದಾಣಿಕೆ",
        tagMentorship: "ಮಾರ್ಗದರ್ಶನ",
        tagFunding: "ಧನಸಹಾಯ",
        tagAI: "ಆರ್ಟಿಫಿಶಿಯಲ್ ಇಂಟೆಲಿಜೆನ್ಸ್",
        tagBusinessGuidance: "ವ್ಯಾವಸಾಯಿಕ ಮಾರ್ಗದರ್ಶನ",
        tagDecisionSupport: "ನಿರ್ಧಾರ ಬೆಂಬಲ",
        tagStrategy: "ಕಾರ್ಯತಂತ್ರ",
    },

    // --- ARRAYS ---
    // All 4 HowWeWork step titles
    hwwSteps: [
        "ಆಳವಾದ ಅನ್ವೇಷಣೆ",
        "ಕಾರ್ಯತಂತ್ರ ಆರ್ಕಿಟೆಕ್ಚರ್",
        "ನಿಖರವಾದ ಎಂಜಿನಿಯರಿಂಗ್",
        "ಉಡಾವಣೆ ಮತ್ತು ವಿಸ್ತರಣೆ",
    ],

    homeFeatures: [
        "ಡಿಜಿಟಲ್ ಟ್ರಾನ್ಸ್‌ಫಾರ್ಮೇಶನ್",
        "ಸ್ಟಾರ್ಟ್ಅಪ್ ಎಕೋಸಿಸ್ಟಂ",
        "AI ಮತ್ತು ಸ್ಮಾರ್ಟ್ ಪರಿಹಾರಗಳು",
        "ವಿನ್ಯಾಸ ಮತ್ತು ಬ್ರಾಂಡಿಂಗ್",
    ],

    homeFeatureDescs: [
        "ಎಂಟರ್‌ಪ್ರೈಸ್-ಗ್ರೇಡ್ ವೆಬ್‌ಸೈಟ್‌ಗಳು, ಮೊಬೈಲ್ ಅಪ್ಲಿಕೇಶನ್‌ಗಳು ಮತ್ತು ಬುದ್ಧಿವಂತ ಆಟೊಮೇಷನ್ ಫ್ರೇಮ್‌ವರ್ಕ್‌ಗಳ ಮೂಲಕ ನಿಮ್ಮ ಸಂಸ್ಥೆಯ ಡಿಜಿಟಲ್ ಅಡಿಪಾಯವನ್ನು ಬಲಪಡಿಸಿ.",
        "ವೇಗವರ್ಧಿತ ಬೆಳವಣಿಗೆ ಮತ್ತು ಸುಸ್ಥಿರ ವ್ಯವಹಾರದ ಫಲಿತಾಂಶಗಳನ್ನು ಬೆಳೆಸುವ ಹೂಡಿಕೆದಾರರು, ಸಂಪನ್ಮೂಲಗಳು ಮತ್ತು ಸ್ಕೇಲೆಬಲ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ಗಳನ್ನು ಪ್ರವೇಶಿಸಲು ಸಂಸ್ಥಾಪಕರನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ.",
        "ನಿರ್ಣಾಯಕ ವರ್ಕ್ಫ್ಲೋಗಳನ್ನು ಸ್ವಯಂಚಾಲಿತಗೊಳಿಸುವ, ಕ್ರಿಯಾಶೀಲ ಒಳನೋಟಗಳನ್ನು உருவாಕೆ ಮಾಡುವ ಮತ್ತು ಹೂಡಿಕೆಯ ಮೇಲೆ ಅಳೆಯಬಹುದಾದ ಆದಾಯವನ್ನು ನೀಡುವ ಬುದ್ಧಿವಂತ ವ್ಯವಸ್ಥೆಗಳನ್ನು ನಿಯೋಜಿಸಿ.",
        "ಸುಧಾರಿತ ಬಳಕೆದಾರ ಅನುಭವಗಳು, ವಿಶಿಷ್ಟವಾದ ಬ್ರ್ಯಾಂಡ್ ಗುರುತುಗಳು ಮತ್ತು ಸಾಂಸ್ಥಿಕ ಉದ್ದೇಶಗಳೊಂದಿಗೆ ಹೊಂದಿಕೆಯಾಗುವ ಕಾರ್ಯತಂತ್ರದ ಸಂವಹನ ಸ್ವತ್ತುಗಳನ್ನು ರಚಿಸಿ.",
    ],

    servicesList: [
        "ವೆಬ್‌ಸೈಟ್ ಅಭಿವೃದ್ಧಿ",
        "ವೆಬ್ ವಿನ್ಯಾಸ ಮತ್ತು UI/UX",
        "ಸಾಫ್ಟ್ವೇರ್ ಅಭಿವೃದ್ಧಿ",
        "AI ಮತ್ತು ಚಾಟ್ಬಾಟ್",
        "ಲಾಯಲ್ಟಿ ಕಾರ್ಯಕ್ರಮಗಳು",
        "ಶೈಕ್ಷಣಿಕ ತಂತ್ರಜ್ಞಾನ",
    ],

    servicesListDescs: [
        "ನಿಮ್ಮ ಅನನ್ಯ ವ್ಯವಹಾರ ಅಗತ್ಯಗಳು ಮತ್ತು ಗುರಿಗಳಿಗೆ ಅನುಗುಣವಾಗಿ ಕಸ್ಟಮ್ ವೆಬ್‌ಸೈಟ್ ಅಭಿವೃದ್ಧಿ.",
        "ನಿಮ್ಮ ಪ್ರೇಕ್ಷಕರನ್ನು ತೊಡಗಿಸಿಕೊಳ್ಳುವ ಅರ್ಥಗರ್ಭಿತ ಬಳಕೆದಾರ ಅನುಭವಗಳೊಂದಿಗೆ ದೃಷ್ಟಿಗೋಚರವಾಗಿ ಬೆರಗುಗೊಳಿಸುವ ವಿನ್ಯಾಸಗಳು.",
        "ಕಾರ್ಯಾಚರಣೆಗಳನ್ನು ಸುಗಮಗೊಳಿಸುವ ಮತ್ತು ವ್ಯವಹಾರದ ಬೆಳವಣಿಗೆಯನ್ನು ಹೆಚ್ಚಿಸುವ ಕಸ್ಟಮ್ ಸಾಫ್ಟ್ವೇರ್ ಪರಿಹಾರಗಳು.",
        "ಗ್ರಾಹಕರ ಅನುಭವ ಮತ್ತು ನಿಶ್ಚಿತಾರ್ಥವನ್ನು ಹೆಚ್ಚಿಸಲು ಬುದ್ಧಿವಂತ ಸಂವಾದಾತ್ಮಕ ಇಂಟರ್ಫೇಸ್ಗಳು.",
        "ನಿಮ್ಮ ವ್ಯವಹಾರಕ್ಕಾಗಿ ಗ್ರಾಹಕರ ನಿಷ್ಠೆಯನ್ನು ನಿರ್ಮಿಸಲು ಮತ್ತು ನಿರ್ವಹಿಸಲು ಸಮಗ್ರ ಪರಿಹಾರಗಳು.",
        "ಕಲಿಕೆಯ ಅನುಭವಗಳು ಮತ್ತು ಶೈಕ್ಷಣಿಕ ಫಲಿತಾಂಶಗಳನ್ನು ಹೆಚ್ಚಿಸಲು ನವೀನ ಡಿಜಿಟಲ್ ಪರಿಹಾರಗಳು.",
    ],

    timelineSteps: [
        "ಡಿಸ್ಕವರಿ ಕಾಲ್",
        "ಕಾರ್ಯತಂತ್ರ ಮತ್ತು ಸ್ಕೋಪಿಂಗ್",
        "ಡಿಸೈನ್ ಸ್ಪ್ರಿಂಟ್",
        "ಬಿಲ್ಡ್ & ಇಟರೇಟ್",
        "ಲಾಂಚ್ & ಸಪೋರ್ಟ್",
    ],

    timelineStepBodies: [
        "ನಿಮ್ಮ ಗುರಿಗಳು, ನಿರ್ಬಂಧಗಳು ಮತ್ತು ಯಶಸ್ಸಿನ ಮಾಪನಗಳನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಲು ಕೇಂದ್ರೀಕೃತ ಸಂಭಾಷಣೆ.",
        "ನಾವು ವಿವರವಾದ ತಾಂತ್ರಿಕ ವ್ಯಾಪ್ತಿ, ಟೈಮ್ಲೈನ್ ಮತ್ತು ಹೂಡಿಕೆ ವಿಭಜನೆಯನ್ನು ಉತ್ಪಾದಿಸುತ್ತೇವೆ. ಯಾವುದೇ ಆಶ್ಚರ್ಯಗಳಿಲ್ಲ.",
        "ಕೋಡ್‌ನ ಒಂದೇ ಸಾಲನ್ನು ಬರೆಯುವ ಮೊದಲು ಹೈ-ಫಿಡೆಲಿಟಿ ವೈರ್‌ಫ್ರೇಮ್‌ಗಳು ಮತ್ತು ವಿನ್ಯಾಸದ ಮೂಲಮಾದರಿಗಳನ್ನು ಪರಿಶೀಲಿಸಲಾಗಿದೆ ಮತ್ತು ಅನುಮೋದಿಸಲಾಗಿದೆ.",
        "ಸಾಪ್ತಾಹಿಕ ಡೆಮೊಗಳೊಂದಿಗೆ ಅಗೈಲ್ ಸ್ಪ್ರಿಂಟ್ ಗಳು. ಎಲ್ಲಾ ಸಮಯದಲ್ಲೂ ಪ್ರಗತಿಯ ಬಗ್ಗೆ ನೀವು ಸಂಪೂರ್ಣ ಗೋಚರತೆಯನ್ನು ಹೊಂದಿದ್ದೀರಿ.",
        "ನಿಯೋಜನೆ, ಮೇಲ್ವಿಚಾರಣೆ, ಕಾರ್ಯಕ್ಷಮತೆ ಆಪ್ಟಿಮೈಸೇಶನ್, ಮತ್ತು ಬೆಳವಣಿಗೆಗೆ ನಿರಂತರ ಪಾಲುದಾರಿಕೆ.",
    ],

    valuesSectionValues: [
        "ಆವಿಷ್ಕಾರ",
        "ಸ್ಕೇಲೆಬಿಲಿಟಿ",
        "ಸಬಲೀಕರಣ",
    ],
};

export default kn;
